<template>
  <button
    type="button"
    class="store-filters-toggle"
    @click="toggleFilters"
  >
    <span
      v-if="filtersVisible"
    >
      Hide Filters
      <svg
        data-icon="chevron"
        aria-hidden="true"
        viewBox="0 0 20 11"
        style="transform: rotate(180deg)"
      >
        <use xlink:href="/resources/app/client/dist/spritemap.svg#sprite-chevron" />
      </svg>
    </span>

    <span
      v-if="!filtersVisible"
    >
      Show Filters
      <svg
        data-icon="chevron"
        aria-hidden="true"
        viewBox="0 0 20 11"
      >
        <use xlink:href="/resources/app/client/dist/spritemap.svg#sprite-chevron" />
      </svg>
    </span>
  </button>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'FiltersToggle',

  computed: {
    ...mapState([
      'filtersVisible'
    ])
  },

  methods: {
    ...mapMutations([
      'toggleFilters'
    ])
  }
}
</script>
